module.exports = __webpack_public_path__ + "static/media/bg-field.0a7b6ab8.png";